<template>

  <div class="group" :ref="refs[builder.doorProfile.fieldName + 'Group']">

    <div class="group-header l_no-footspace" :id="`${builder.doorProfile.fieldName}Title`">
      <div class="group-title">Choose your door profile:</div>
    </div>

    <Selector
      :key=builder.doorProfile.fieldName
      :field-name=builder.doorProfile.fieldName
      :display-type=builder.doorProfile.displayType
      :options=builder.doorProfile.options
      :selected=builder.currentItem.specs[builder.doorProfile.fieldName]
      options-source="doorProfileOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.panelFinish.fieldName + 'Group']">

    <div class="group-header l_no-footspace" :id="`${builder.panelFinish.fieldName}Title`">
      <div class="group-title">Choose your door and panel finishes:</div>
    </div>
    
    <div style="margin-top: 20px;" v-if="!builder.currentItem.specs.doorProfileId">
      <p>Please select a door profile to view the finish options.</p>
    </div>

    <Selector
      :key=builder.panelFinish.fieldName
      :field-name=builder.panelFinish.fieldName
      :display-type=builder.panelFinish.displayType
      :options=builder.panelFinish.options
      :selected=builder.currentItem.specs[builder.panelFinish.fieldName]
      options-source="panelFinishOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.benchtopMaterial.fieldName + 'Group']">
    
    <hr class="l_light">

    <div class="group-header l_no-footspace" :id="`${builder.benchtopMaterial.fieldName}Title`">
      <div class="group-title">Choose your benchtop material</div>
    </div>

    <Selector
      :key=builder.benchtopMaterial.fieldName
      :field-name=builder.benchtopMaterial.fieldName
      :display-type=builder.benchtopMaterial.displayType
      :options=builder.benchtopMaterial.options
      :selected=builder.currentItem.specs[builder.benchtopMaterial.fieldName]
      options-source="benchtopMaterialOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>
  
  <div class="group" :ref="refs[builder.benchCutouts.fieldName + 'Group']" v-if="builder.showBenchCutoutsOption">
    
    <hr class="l_light">
    
    <div class="group-header l_stacked" :id="`${builder.benchCutouts.fieldName}Title`">
      <div class="group-title">Do you require any bench cut-outs for a sink or cook-top?</div>
      <div class="group-help">Cutouts are only required for stone benchtop selections.</div>
    </div>

    <Selector
      :key=builder.benchCutouts.fieldName
      :field-name=builder.benchCutouts.fieldName
      :display-type=builder.benchCutouts.displayType
      :options=builder.benchCutouts.options
      :selected=builder.currentItem.specs[builder.benchCutouts.fieldName]
      options-source="benchCutoutsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>
    
  </div>
  
  <!-- <div class="group" :ref="refs[builder.requireHandles.fieldName + 'Group']">
    
    <hr class="l_light">
    
    <div class="group-header" :id="`${builder.requireHandles.fieldName}Title`">
      <div class="group-title">Would you like handles for your cupboards and drawers?</div>
    </div>

    <Selector
      :key=builder.requireHandles.fieldName
      :field-name=builder.requireHandles.fieldName
      :display-type=builder.requireHandles.displayType
      :options=builder.requireHandles.options
      :selected=builder.currentItem.specs[builder.requireHandles.fieldName]
      options-source="requireHandlesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>
    
  </div> -->

  <!--  v-if="builder.showHandlesOptions" -->
  <div class="group" :ref="refs[builder.handles.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.handles.fieldName}Title`">
      <div class="group-title">Choose your handles</div>
    </div>

    <Selector
      :key=builder.handles.fieldName
      :field-name=builder.handles.fieldName
      :display-type=builder.handles.displayType
      :options=builder.handles.options
      :selected=builder.currentItem.specs[builder.handles.fieldName]
      options-source="handlesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>
  
  <!-- <div class="group" :ref="refs[builder.requireDesignAppointment.fieldName + 'Group']">
    
    <hr class="l_light">
    
    <div class="group-header" :id="`${builder.requireDesignAppointment.fieldName}Title`">
      <div class="group-title">Please contact me to adjust my design?</div>
    </div>

    <Selector
      :key=builder.requireDesignAppointment.fieldName
      :field-name=builder.requireDesignAppointment.fieldName
      :display-type=builder.requireDesignAppointment.displayType
      :options=builder.requireDesignAppointment.options
      :selected=builder.currentItem.specs[builder.requireDesignAppointment.fieldName]
      options-source="requireDesignAppointmentOptions"
      scope="specs"
      @select-option="select"
    ></Selector>
    
  </div>
  
  <div class="group" :ref="refs[builder.preferredContactMethod.fieldName + 'Group']" v-if="builder.currentItem.specs[builder.requireDesignAppointment.fieldName]">
    
    <hr class="l_light">
    
    <div class="group-header" :id="`${builder.preferredContactMethod.fieldName}Title`">
      <div class="group-title">How would you like to be contacted?</div>
    </div>

    <Selector
      :key=builder.preferredContactMethod.fieldName
      :field-name=builder.preferredContactMethod.fieldName
      :display-type=builder.preferredContactMethod.displayType
      :options=builder.preferredContactMethod.options
      :selected=builder.currentItem.specs[builder.preferredContactMethod.fieldName]
      options-source="preferredContactMethodOptions"
      scope="specs"
      @select-option="select"
    ></Selector>
    
  </div>

  <div class="group l_sub-group" :ref="refs['EmailGroup']" v-if="builder.currentItem.specs[builder.requireDesignAppointment.fieldName]">

    <div class="group-header" :id="`EmailTitle`">
      <div class="group-title">We'll need a few more details so we can get in touch:</div>
    </div>
    
    <label for="firstName" style="margin-bottom: 10px;">First Name</label>

    <Text-Input
    key="firstName"
    field-label="firstName"
    field-name="firstName"
    :init-value=builder.quote.firstName
    :init-touched="false"
    scope="quote"
    @update-value="updateQuoteValue"
    ></Text-Input>
    
    <label for="email" style="margin-top: 20px; margin-bottom: 10px;">Email</label>

    <Text-Input
    key="email"
    field-label="email"
    field-name="email"
    field-type="email"
    :init-value=builder.quote.email
    :init-touched="false"
    scope="quote"
    @update-value="updateQuoteValue"
    ></Text-Input>
    
    <label for="phone" style="margin-top: 20px; margin-bottom: 10px;" v-if="builder.currentItem.specs[builder.preferredContactMethod.fieldName] == 'phone'">Phone</label>

    <Text-Input
    key="phone"
    field-label="phone"
    field-name="phone"
    field-type="phone"
    :init-value=builder.quote.phone
    :init-touched="false"
    scope="quote"
    @update-value="updateQuoteValue"
    v-if="builder.currentItem.specs[builder.preferredContactMethod.fieldName] == 'phone'"
    ></Text-Input>

  </div> -->

  
</template>

<script setup>
  
import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function updateValue(prop, val) {
  builder.setCurrentItemSpec(prop, val);
}

function updateQuoteValue(prop, val) {
  builder.quote[prop] = val;
}

const initialValue = computed(() => {
  if (!_.isUndefined(builder.currentItem) && !_.isUndefined(builder.currentItem.specs) && !_.isUndefined(builder.currentItem.specs[builder.modifications.fieldName])) {
    return builder.currentItem.specs[builder.modifications.fieldName];
  }
  return null;
})

// init refs
let refHandles = [
  builder.panelFinish.fieldName + 'Group',
  builder.benchtopMaterial.fieldName + 'Group',
  builder.benchCutouts.fieldName + 'Group',
  builder.requireHandles.fieldName + 'Group',
  builder.handles.fieldName + 'Group',
  builder.requireDesignAppointment.fieldName + 'Group',
  builder.preferredContactMethod.fieldName + 'Group',
  'EmailGroup'
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>